/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useEffect, useRef, useState } from 'react';
import {TextField, Autocomplete, FormControl, Checkbox, InputAdornment, IconButton, Chip} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from 'moment';
import { HugeiconsIcon } from '@hugeicons/react';
// @ts-ignore
import { ArrowDown01Icon, Download04Icon, Cancel01Icon } from '@hugeicons-pro/core-stroke-standard';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { exportPLDReport } from 'src/services/reportService';
import CsvService from 'src/services/dataExport.service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useLocation } from 'react-router-dom';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import type { TableColumn } from 'react-data-table-component';
import type { RootState } from '../../store/store';
import { useSelector } from 'react-redux';
import type { PLDReportType } from '../types/types';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { getAllCampaigns } from 'src/services/campaignService';
import { getResendStatus } from 'src/services/campaignService';


interface FormValues {
  startDate: string;
  endDate: string;
  campaingId?: number;
}

const PLDReport: React.FC = (): JSX.Element => {
  const location = useLocation();
  const state = location.state as { start?: Date; end?: Date } | null;
  const today = new Date();

  // Calculate default start date as 1 month before today
  const defaultStart = new Date();
  defaultStart.setMonth(today.getMonth() - 1);
  
  // Use location state dates if provided, otherwise use defaults
  const { start = defaultStart, end = today } = state ?? {};
  
  const [isDataLoading, setIsDataLoading] = useState(false);
  const dateRangeRef: any = useRef(null);
  const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false)
  const [fromDate, setFromDate] = useState<any>(start)
  const [endDate, setEndDate] = useState<any>(end)
  const [reportDateRange, setReportDateRange] = useState<any>()
  const [reportData, setReportData] = useState<any>([])
  const { user} = useSelector((state: RootState) => state.auth);
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [isCampaignLoading, setIsCampaignLoading] = useState<boolean>(false);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [selectedStatuses, setSelectedStatuses] = useState<any[]>([]);
  const [isStatusLoading, setIsStatusLoading] = useState<boolean>(false);
  const [isCampaignSelected, setIsCampaignSelected] = useState<boolean>(false);
  const [selectedStatusIds, setSelectedStatusIds] = useState<string>('');
  const [selectedStatusNames, setSelectedStatusNames] = useState<string>('');


 
  const validationSchema = Yup.object().shape({  
    startDate: Yup.string().required("Report start date required")
      .test("valid-date", "Invalid date format", (value) =>
        moment(value, "YYYY-MM-DD", true).isValid()
      ),
    endDate: Yup.string().required("Report end date required")
      .test("valid-date", "Invalid date format", (value) =>
        moment(value, "YYYY-MM-DD", true).isValid()
      )
      .test("endAfterStart", "End date must be after start date", function (value) {
        const { startDate } = this.parent;
        return moment(value, "YYYY-MM-DD").isSameOrAfter(moment(startDate, "YYYY-MM-DD"));
      })
  });

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      startDate: moment(start).format('YYYY-MM-DD'),
      endDate: moment(end).format('YYYY-MM-DD'), 
    },
    mode: 'onChange' // This will validate on every change
  });
  useEffect(() => {
  const today = new Date();
  const defaultStart = new Date();
  defaultStart.setMonth(today.getMonth() - 1);

  // Reset date state
  setFromDate(defaultStart);
  setEndDate(today);
  setReportDateRange({
    startDate: defaultStart,
    endDate: today,
    key: 'selection',
  });

  // Reset form values
  reset({
    startDate: moment(defaultStart).format('YYYY-MM-DD'),
    endDate: moment(today).format('YYYY-MM-DD'),
    campaingId: undefined,
  });

  setValue('campaingId', undefined);
  // Reset other state
  setCampaigns([]);
  setReportData([]);
  setSelectedStatuses([]);
  setSelectedStatusIds('');
  setSelectedStatusNames('');
  setStatusOptions([]);
  setIsCampaignSelected(false);

  // Pass dates explicitly to avoid stale closure
  void onSubmit(defaultStart, today);
}, [user]);


    const handleClearDateRange = (): void => {
        const today = new Date();
        const defaultStart = new Date();
        defaultStart.setMonth(today.getMonth() - 1);

        // Only update date fields, don't use reset()
        setValue('startDate', moment(defaultStart).format('YYYY-MM-DD'), { shouldValidate: true });
        setValue('endDate', moment(today).format('YYYY-MM-DD'), { shouldValidate: true });

        setFromDate(defaultStart);
        setEndDate(today);
        setReportDateRange({
            startDate: defaultStart,
            endDate: today,
            key: 'selection',
        });
    }

    const onSubmit = async (customStartDate?: Date, customEndDate?: Date): Promise<void> => {
  const isFormValid = await trigger();
  if (!isFormValid) return;

  const clientId = Number(user?.clientId ?? 0);
  const startDateToUse = customStartDate ?? fromDate;
  const endDateToUse = customEndDate ?? endDate;

  const formattedStartDate = moment(startDateToUse).format('YYYY-MM-DD');
  const formattedEndDate = moment(endDateToUse).format('YYYY-MM-DD');

  const sentOrdersPayload = (() => {
    if (!selectedStatuses || selectedStatuses.length === 0) {
        return [-1]; // default = ALL
    }

    const hasAll = selectedStatuses.some((s: any) => s.id === -1);

    if (hasAll) {
        return [-1];
    }

    return selectedStatuses.map((s: any) => s.id);
    })();


  setIsDataLoading(true);

  exportPLDReport(
  clientId,
  formattedStartDate,
  formattedEndDate,
  watch('campaingId'),
  sentOrdersPayload
)
  .then((res: any) => {
    if (res.status === 200 && res.data?.success === true) {
      const data = res.data?.data ?? [];
      
      if (data.length === 0) {
        setReportData([]);
        console.log('PLD Report Data: No data available');
        NotificationManager.error('No data available', '', 5000);
      } else {
        setReportData(data);
        console.log('PLD Report Data:', data);
      }
    } else {
      setReportData([]);
      console.log('PLD Report Data: Request failed');
      NotificationManager.error('Failed to fetch report data', '', 5000);
    }
  })
  .catch((error) => {
    console.error('PLD Report Error:', error);
    setReportData([]);
    NotificationManager.error('Unknown error has occurred', '', 5000);
  })
  .finally(() => setIsDataLoading(false));
};

    const onFormSubmit = async (): Promise<void> => {
        await onSubmit();
    }
    const formatExportDate = (date: string | null | undefined): string =>
        (date != null) ? moment(date).format("MM-DD-YYYY HH:mm:ss") : "N/A";

    const handleExportReport = (): void => {
        if (!reportData || reportData.length === 0) {
            NotificationManager.error('No data available for download', '', 5000);
            return;
        }

        const data = reportData.map((item: any) => ({
            "Vendor Name": item.vendorName ?? '',
            "Brand Name": item.brandName ?? '',
            "Disease State": item.diseaseState ?? '',
            "Campaign Type": item.campaignType ?? '',
            "Campaign Name": item.campaignName ?? '',
            "Custom Program Flag": item.customProgramFlag ?? '',

            "Transaction ID": item.transactionId ?? '',
            "Activity Date": item.activityDate
            ? moment(item.activityDate).format("MM-DD-YYYY HH:mm:ss")
            : '',
            "NPI": item.npi ?? '',
            "Activity Code": item.activityCode ?? '',
            "Reach Engagement Indicator": item.reachEngagementIndicator ?? '',

            "Creative ID": item.creativeId ?? '',
            "Content Description": item.contentDesc ?? '',
            "Placement URL": item.placementUrl ?? '',
            "Device Type": item.deviceType ?? '',
            "Subject Line": item.subjectLine ?? '',
            "URL Clicked": item.urlClicked ?? ''
        }));

        const clientName =
            user?.selectedClientName
            ? user.selectedClientName.replaceAll(' ', '_')
            : 'Client';

        CsvService.downloadXlsFile(
            data,
            `${clientName}_PLD_Report.xlsx`
        );
    };

    
const handleDateRangeClick = (ranges: any): void => {
const selectedStart = moment(ranges.selection.startDate).startOf('day').toDate();
const selectedEnd = moment(ranges.selection.endDate).endOf('day').toDate();

// Detect if user is selecting only one date (same start & end)
const isSingleSelection = moment(selectedStart).isSame(selectedEnd, 'day');

if (isSingleSelection) {
    // for 'Today' and 'Yesterday' — set both start and end to same day
    setFromDate(selectedStart);
    setEndDate(selectedStart);
    setReportDateRange({
    startDate: selectedStart,
    endDate: selectedStart,
    key: 'selection'
    });
    setValue('startDate', moment(selectedStart).format('YYYY-MM-DD'), { shouldValidate: true });
    setValue('endDate', moment(selectedStart).format('YYYY-MM-DD'), { shouldValidate: true });
} else {
    // Normal multi-date selection
    setFromDate(selectedStart);
    setEndDate(selectedEnd);
    setReportDateRange({
    startDate: selectedStart,
    endDate: selectedEnd,
    key: 'selection'
    });
    setValue('startDate', moment(selectedStart).format('YYYY-MM-DD'), { shouldValidate: true });
    setValue('endDate', moment(selectedEnd).format('YYYY-MM-DD'), { shouldValidate: true });
}
};

  const handleDateChange = (): void => {
    setIsDateRangeOpen(true)
    setReportDateRange({
      startDate: fromDate,
      endDate: endDate,
      key: 'selection'
    })
  }

    useEffect(() => {
        const clientId = Number(user?.clientId ?? 0);

        // ← ADD THESE THREE LINES
        setCampaigns([]);
        setStatusOptions([]);
        setIsCampaignSelected(false);

        if (!clientId) return;

        setIsCampaignLoading(true);
        getAllCampaigns(clientId)
            .then((res: any) => {
            if (res.status === 200 && res.data.result === 1) {
                setCampaigns(
                res.data.data.map((c: any) => ({ campaignId: c.campaignId, name: c.name }))
                );
            } else {
                setCampaigns([]);
            }
            })
            .finally(() => setIsCampaignLoading(false));
        }, [user]);

    const isAllSelected = selectedStatuses.some(
        (s: any) => s.resendStatus === 'All'
    );

    const selectedSentOrderIds = selectedStatuses
    .filter((s: any) => s.resendStatus !== 'All')
    .map((s: any) => s.id);

  // Initialize date range on component mount
  useEffect(() => {
    setReportDateRange({
      startDate: fromDate,
      endDate: endDate,
      key: 'selection'
    });
  }, [fromDate, endDate]);

    const formatDate = (date?: string | null): string => {
        return (date != null) ? moment(date).format("MM/DD/YYYY") : "N/A";
    };
    useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
        if (dateRangeRef.current && !dateRangeRef.current.contains(event.target)) {
        setIsDateRangeOpen(false);

        // Keep whatever date range was last selected
        setFromDate(reportDateRange?.startDate);
        setEndDate(reportDateRange?.endDate);

        setValue('startDate', moment(reportDateRange?.startDate).format('YYYY-MM-DD'));
        setValue('endDate', moment(reportDateRange?.endDate).format('YYYY-MM-DD'));
        }
    };

    if (isDateRangeOpen) {
        document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
    }, [isDateRangeOpen, reportDateRange, setValue]);
    const columns: TableColumn<PLDReportType>[] = [
    {
        name: 'NPI',
        selector: (row: PLDReportType) => row.npi,
        width: '10%',
        wrap: true,
        sortable: true
    },
    {
        name: 'Campaign Name',
        selector: (row: PLDReportType) => row.campaignName,
        width: '14%',
        wrap: true,
        sortable: true,
        cell: (row: PLDReportType) => (
            <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>   
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
                    <CustomTooltip title={row.campaignName} placement="bottom" arrow={false}>
                    <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.campaignName}</p>
                    </CustomTooltip>
                </div>
            </div>
        )
    },
    {
        name: 'Brand',
        selector: (row: PLDReportType) => row.brandName,
        width: '12%',
        wrap: true,
        sortable: true,
        cell: (row: PLDReportType) => (
            <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>   
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
                    <CustomTooltip title={row.brandName} placement="bottom" arrow={false}>
                    <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.brandName}</p>
                    </CustomTooltip>
                </div>
            </div>
        )
    },
    {
        name: 'Activity Code',
        selector: (row: PLDReportType) => row.activityCode,
        width: '10%',
        wrap: true,
        sortable: true,
        cell: (row: PLDReportType) => (
            <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>   
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
                    <CustomTooltip title={row.activityCode} placement="bottom" arrow={false}>
                    <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.activityCode}</p>
                    </CustomTooltip>
                </div>
            </div>
        )
    },
    {
        name: 'Activity Date',
        selector: (row: PLDReportType) => formatDate(row.activityDate),
        width: '12%',
        wrap: true,
        cell: (row: PLDReportType) => (
            <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>   
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
                    <CustomTooltip title={formatDate(row.activityDate)} placement="bottom" arrow={false}>
                    <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{formatDate(row.activityDate)}</p>
                    </CustomTooltip>
                </div>
            </div>
        )
    },
    {
        name: 'Device Type',
        selector: (row: PLDReportType) => row.deviceType,
        width: '10%',
        wrap: true,
        sortable: true,
        cell: (row: PLDReportType) => (
            <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>   
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
                    <CustomTooltip title={row.deviceType} placement="bottom" arrow={false}>
                    <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.deviceType}</p>
                    </CustomTooltip>
                </div>
            </div>
        )
    },
    {
        name: 'URL Clicked',
        selector: (row: PLDReportType) => row.urlClicked,
        width: '10%',
        wrap: true,
        cell: (row: PLDReportType) => (
            <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
                {row.urlClicked ? (
                <CustomTooltip title={row.urlClicked} placement="bottom" arrow={false}>
                    <a
                    href={row.urlClicked}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline overflow-hidden text-ellipsis whitespace-nowrap w-full"
                    >
                    View
                    </a>
                </CustomTooltip>
                ) : (
                <span></span>
                )}
            </div>
            </div>
        )
    },
    {
        name: 'Transaction ID',
        selector: (row: PLDReportType) => row.transactionId,
        width: '20%',
        wrap: true,
        sortable: true,
        cell: (row: PLDReportType) => (
            <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>   
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
                    <CustomTooltip title={row.transactionId} placement="bottom" arrow={false}>
                    <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.transactionId}</p>
                    </CustomTooltip>
                </div>
            </div>
        )
    }
    ];

    return (
            <>
            <h2 className="text-2xl font-semibold text-title">PLD Reports</h2>
            <div className="mt-[20px] mb-[20px] live-outreach-container">
                <form onSubmit={handleSubmit(onFormSubmit)}  className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-5">
                    <div className="w-full lg:w-auto">                         
                        <FormControl fullWidth>
                            <Controller
                                key={user?.clientId}
                                name="campaingId"
                                control={control}
                                render={({ field, fieldState }) => (
                                <Autocomplete
                                    key={user?.clientId}
                                    options={campaigns}
                                    loading={isCampaignLoading}
                                    getOptionLabel={(option: any) => {
                                    if (!option) return '';
                                    // Display name based on campaign type
                                    const displayName = option.name || '';
                                    return displayName;
                                    }}
                                    popupIcon={
                                    isCampaignLoading ? (
                                        <span className="loading loading-spinner loading-sm text-gray-400"></span>
                                    ) : (
                                        <HugeiconsIcon
                                        icon={ArrowDown01Icon}
                                        size={18}
                                        color="#3A3A3A"
                                        strokeWidth={0.5}
                                        />
                                    )
                                    }
                                    isOptionEqualToValue={(option, value) => option?.campaignId === value}
                                    value={campaigns.find((c) => c.campaignId === field.value) || null}
                                    onChange={(_, selectedClient) => {
                                        const id = selectedClient?.campaignId ?? 0;
                                        field.onChange(id);

                                        // Enable status dropdown only after campaign selection
                                        setIsCampaignSelected(id > 0);

                                        // Reset statuses when campaign changes
                                        setSelectedStatuses([]);
                                        setSelectedStatusIds('');
                                        setSelectedStatusNames('');

                                        // Fetch status options based on selected campaign
                                        if (id > 0) {
                                            setIsStatusLoading(true);
                                            getResendStatus(id, undefined, 'TriggerCampaign')
                                                .then((res: any) => {
                                                    if (res.status === 200 && res.data.result === 1) {
                                                        setStatusOptions(res.data.data);
                                                    } else {
                                                        setStatusOptions([]);
                                                    }
                                                })
                                                .catch((error) => {
                                                    console.error('Error fetching status options:', error);
                                                    setStatusOptions([]);
                                                })
                                                .finally(() => setIsStatusLoading(false));
                                        } else {
                                            // Clear status options if no campaign selected
                                            setStatusOptions([]);
                                        }
                                    }}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Campaign"
                                        placeholder="Select Campaign"
                                        error={fieldState.invalid}
                                        helperText={
                                        fieldState.error && (
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <img
                                                src="/assets/images/attention.svg"
                                                alt="error"
                                                width={14}
                                                height={14}
                                            />
                                            {fieldState.error.message}
                                            </span>
                                        )
                                        }
                                        autoComplete="off"
                                        fullWidth
                                        sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '40px',
                                            height: '40px',
                                            width: '200px',
                                        },
                                        }}
                                    />
                                    )}
                                    sx={{
                                    '& .MuiAutocomplete-clearIndicator': {
                                        marginRight: '-12px'
                                    },
                                    '& .MuiAutocomplete-input': {
                                        width: '70%'
                                    }
                                    }}
                                />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="w-full lg:w-auto">                         
                        <FormControl fullWidth>
                            <Autocomplete
                                multiple
                                limitTags={1}
                                options={statusOptions}
                                loading={isStatusLoading}
                                disabled={!isCampaignSelected}
                                value={selectedStatuses}
                                getOptionLabel={(option) => option.resendStatus || ''}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                disableCloseOnSelect
                                getOptionDisabled={(option) =>
                                    isAllSelected && option.resendStatus !== 'All'
                                }
                                // Add this prop to customize the "+X" text and prevent dropdown
                                getLimitTagsText={(more) => `+${more}`}
                                // Add renderTags to prevent dropdown on count click
                                renderTags={(value, getTagProps) => {
                                    const numTags = value.length;
                                    const limitTags = 1;

                                    return (
                                        <>
                                            {value.slice(0, limitTags).map((option, index) => (
                                                <Chip
                                                    {...getTagProps({ index })}
                                                    key={option.id}
                                                    label={option.resendStatus}
                                                />
                                            ))}
                                            {numTags > limitTags && (
                                                <span 
                                                    style={{ 
                                                        marginLeft: '4px', 
                                                        color: 'rgba(0, 0, 0, 0.6)',
                                                        fontSize: '0.875rem',
                                                        pointerEvents: 'none',
                                                        userSelect: 'none'
                                                    }}
                                                >
                                                    +{numTags - limitTags}
                                                </span>
                                            )}
                                        </>
                                    );
                                }}
                                onChange={(_, newValue) => {
                                    const hasAll = newValue.some(
                                        (s: any) => s.resendStatus === 'All'
                                    );

                                    if (hasAll) {
                                        // Keep ONLY "All"
                                        setSelectedStatuses(
                                            newValue.filter((s: any) => s.resendStatus === 'All')
                                        );
                                    } else {
                                        setSelectedStatuses(newValue);
                                    }
                                }}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            style={{ marginRight: 8 }}
                                        />
                                        {option.resendStatus}
                                    </li>
                                )}
                                popupIcon={
                                    <HugeiconsIcon
                                        icon={ArrowDown01Icon}
                                        size={18}
                                        color="#3A3A3A"
                                        strokeWidth={0.2}
                                    />
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        variant="outlined"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '40px',
                                                height: '40px',
                                                width: '220px',
                                            },
                                        }}
                                    />
                                )}
                                sx={{
                                    '& .MuiAutocomplete-clearIndicator': {
                                        marginRight: '-12px',
                                    },
                                    '& .MuiAutocomplete-input': {
                                        width: '70%',
                                    },
                                    // Style the limit tags text to match your design
                                    '& .MuiChip-root + .MuiTypography-root': {
                                        cursor: 'default',
                                        pointerEvents: 'none',
                                    },
                                }}
                            />
                        </FormControl>
                    </div>
                {/* Date Range Field */}
                <div className="w-full lg:w-auto">
                    <FormControl>
                    <TextField
                        id="date-range"
                        label="Date Range*"
                        variant="outlined"
                        autoComplete='off'
                        ref={dateRangeRef}
                        InputProps={{
                        endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                            <IconButton
                            onClick={handleClearDateRange}
                            size="small"
                            sx={{ marginRight: '4px' }}
                            >
                            <HugeiconsIcon
                                icon={Cancel01Icon}
                                size={16}
                                color="#666"
                                strokeWidth={0.5}
                            />
                            </IconButton>
                            <HugeiconsIcon
                            icon={Calendar03Icon}
                            size={18}
                            color="#3A3A3A"
                            strokeWidth={0.5}
                            onClick={handleDateChange}
                            />
                        </InputAdornment>
                        }}
                        onChange={handleDateChange}
                        onFocus={handleDateChange}
                        value={`${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}`}
                        sx={{
                        width: { xs: '100%', sm: '230px', md: '230px', lg: '230px' },
                        minWidth: '200px',
                        '& .MuiOutlinedInput-root': {
                            height: '56px',
                            '& .MuiOutlinedInput-input': {
                            padding: '16px 14px',
                            height: 'auto',
                            lineHeight: '1.4375em',
                            },
                        },
                        '& .MuiInputLabel-root': {
                            padding: '0 4px',
                            fontSize: '13px',
                            left: '16px',
                            lineHeight: '1.2',
                        },
                        }}
                    />
                    {(errors.startDate ?? errors.endDate) && (
                        <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px', marginLeft: '14px', lineHeight: '1.2' }}>
                        {errors.startDate?.message ?? errors.endDate?.message ?? ''}
                        </div>
                    )}
                    {isDateRangeOpen && (
                        <div ref={dateRangeRef} style={{ position: 'absolute', zIndex: '999', top: '100%', marginTop: '4px' }}>
                        <DateRangePicker
                            ranges={[reportDateRange]} 
                            onChange={handleDateRangeClick}
                            dateDisplayFormat={'MM/dd/yyyy'}
                            inputRanges={[]}
                            color={"#FFF5F6"}
                            rangeColors={["#D6242C"]}
                            editableDateInputs={true}
                            startDatePlaceholder={"MM/DD/YYYY"}
                            endDatePlaceholder={"MM/DD/YYYY"}
                        />
                        </div>
                    )}
                    </FormControl>
                </div>

                {/* Buttons Section */}
                <div className="flex flex-wrap gap-2 sm:gap-3 lg:gap-2 w-full lg:mt-2">
                    <div className="w-full sm:w-auto">
                    <GradientButton
                        type="submit"
                        color="red"
                        disabled={isDataLoading}
                        width="150px" 
                        onClick={() => void handleSubmit(onFormSubmit)()}
                    >
                        {!isDataLoading ? 'Submit' : (
                        <span className="loading loading-spinner loading-xs text-white"></span>
                        )}
                    </GradientButton>
                    </div>
                    {reportData.length > 0 && 
                    <div className="w-full sm:w-auto">
                        <OutlineButton 
                        onClick={handleExportReport} 
                        type="rounded" 
                        color="gray" 
                        width="150px"
                        >
                        <HugeiconsIcon
                            icon={Download04Icon}
                            size={20}
                            color="#3a3a3a"
                            stroke="0.2"
                        />
                        <span className="ml-[5px]">Download</span>
                        </OutlineButton>
                    </div>
                    }
                </div>
                </form>
            </div>
            <div className='data-table-container te-table-container mb-10'>
                <CustomDataTable
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                columns={columns}
                data={reportData}
                pagination
                //   selectableRows
                progressPending={isDataLoading}
                />
            </div>
            </>
    );
};

export default PLDReport;